import StyledInput from '../../../../styledInput/StyledInput';

/**
 * Formulaire de sélection du motif de désattribution (+ sous-motifs).
 * Utilisé dans AdminModalMissionUnAssign, ModalMissionCancel et ModalMissionInterrupt.
 *
 * @param {object} unassign - valeur retournée par useUnassignReasons()
 */
const UnassignReasonForm = ({ unassign }) => {
  const {
    reasons,
    selectedId,
    setSelectedId,
    selectedReason,
    hasSubReasons,
    subReasonsSelected,
    handleSubReasonsChange,
    noShowError,
  } = unassign;

  return (
    <div className="flex flex-col gap-3">
      <StyledInput
        type="select"
        label="Motif de désattribution"
        value={selectedId}
        onChange={(e) => setSelectedId(e.target.value)}
        list={[
          { value: '', label: 'Sélectionnez un motif' },
          ...reasons.map((r) => ({ value: r._id, label: r.name })),
        ]}
      />
      {noShowError && (
        <div className="bg-red-50 text-red-700 text-sm px-4 py-3 rounded-lg">
          {noShowError}
        </div>
      )}
      {hasSubReasons && (
        <StyledInput
          type="selectMultipleCheckbox"
          label="Précisez le(s) motif(s)"
          value={
            subReasonsSelected.length > 0
              ? `${subReasonsSelected.length} motif(s) sélectionné(s)`
              : 'En savoir plus'
          }
          list={selectedReason.subReasons.map((sr) => ({
            label: sr,
            value: sr,
            checked: subReasonsSelected.includes(sr),
          }))}
          onChange={handleSubReasonsChange}
        />
      )}
    </div>
  );
};

export default UnassignReasonForm;
